function addValidateMethods () {

    // 境内允许输入中文或英文
    $.validator.addMethod('demostic', function (value, element) {

        value = value.replace(/^\s+|\s+$/g, '')
        var demostic = /^([\u4e00-\u9fa5a-zA-Z]+)$/

        return this.optional(element) || (demostic.test(value))

    }, '只能输入中文或英文字母')

    // 新增验证方法，条件必须，满足一定条件则必须
    $.validator.addMethod('required_m', function (value, element) {

        var holder = $(element).attr('placeholder')

        if ($(element).attr('data-required') === 'required') {
            return value != '' && value != holder
        }

        return true

    }, '请输入该信息')
    // 手机号
    $.validator.addMethod('required_iphone', function (value, element) {

      var exg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/

      return this.optional(element) || (exg.test(value))
    }, '请输入正确的手机号')

    //身份证号码
    $.validator.addMethod('required_idcard', function (value, element) {

        var exg = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  
        return this.optional(element) || (exg.test(value))
    }, '请填写正确的18位身份证号码')

    //港澳通行证、台湾通行证、护照
    $.validator.addMethod('required_otherCard', function (value, element) {

        var exg = /^[a-zA-Z0-9]{0,20}$/
  
        return this.optional(element) || (exg.test(value))
    }, '必须为20位以内的字母或数字')

    // 新增验证方法，依赖必须，即如果一条记录输入任何一项，则其他项也必须输入，这就叫“依赖必须”
    $.validator.addMethod('subRequired', function (value, element) {

        value = value.replace(/^\s+|\s+$/g, '')
        var holder = $(element).attr('placeholder')

        if (value != '' && value != holder) return true

        var inputs = $(element).closest('.guest').find('input')

        for (var i = 0; i < inputs.length; i++) {

            var o = inputs[i]

            var n_value = o.value.replace($(o).attr('placeholder'), '')
                .replace(/^\s+|\s+$/g, '')

            if (n_value != '')
                return false

        }

        return true

    }, '请输入该信息')

    //新增验证方法，用户输入预付款时，最多只允许其输入小数点后两位
    $.validator.addMethod('most2pointnum', function (value, element) {

        var most2pointnum = /^(\d+(.\d{1,2})?)$/ //^d*(?:.d{0,2})?$/;

        return this.optional(element) || (most2pointnum.test(value))
    }, '最多只允许输入小数点后两位')

    //新增验证方法，用户输入预付款时，最多只允许其输入小数点后两位
    $.validator.addMethod('allowNumAndWord', function (value, element) {

        var allowNumAndWord = /^[A-Za-z0-9]+$/ //^d*(?:.d{0,2})?$/;

        return this.optional(element) || (allowNumAndWord.test(value))
    }, '最多只允许输入小数点后两位')

    // 中文字三个字节
    $.validator.addMethod('byteRangeLength', function (value, element, param) {
        var length = value.length
        for (var i = 0; i < value.length; i++) {
            if (value.charCodeAt(i) > 127) {
                length += 2
            }
        }
        return this.optional(element) || (length >= param[0] && length <= param[1])
    }, $.validator.format('最多允许输入64位字符'))

    //客户订单号
    $.validator.addMethod('customerCode',function (value, element) {

        var	customerCode = /^[a-zA-Z0-9/-]{0,64}$/;

        return this.optional(element) || (customerCode.test(value));
    }, '不能超过64个字符，仅支持字母、数字、"/"、"-"');
}

// 初始化验证
function InitValidator () {

    if (!$.orderInfo) {
        // 100ms 轮询一次
        return setTimeout(function () {
            InitValidator()
        }, 100)
    }
    // onclick:true

    // 新增自定义的验证方法
    addValidateMethods()

    var o = {
        rules: {
            surname: {
                required_m: true,
                subRequired: true,
            },
            userName: {
                required_m: true,
                subRequired: true,
            },
            countryId: {
                required_m: true,
                subRequired: true,
            },
            voucherEmail: {
                required_m: true,
                email: true,
                rangelength: [0, 64]
            },
            voucherMobile: {
                number: true,
                required_m: true,
                required_iphone: true,
                rangelength: [11, 11]
            },
            willUsedBalance: {
                number: true,
                min: 0,
                most2pointnum: true
            },
            marketingRemark: {
                required: true,
                number: true,
                rangelength: [6, 14]
            },
            voucherCard: {
                required: true,
                rangelength: [0, 64],
                required_idcard: true
            },
            voucherOtherCard: {
                required: true,
                rangelength: [0, 64],
                required_otherCard: true
            },
            useOrderNum: {
                customerCode: true
            }
        },
        messages: {
            voucherEmail: {
                email: '请输入正确的邮箱地址',
                rangelength: '超过最大输入长度'
            },
            voucherMobile: {
                number: '请填写正确的手机号码',
                rangelength: '手机号码长度必须为11位',
            },
            willUsedBalance: {
                number: '请输入数字',
                min: '请输入一个至少大于0的数字',
                max: '您的余额不足或预付款超出本次消费总金额'
            },
            marketingRemark: {
                required: '此项为必填',
                number: '请填写正确的手机号码',
                rangelength: '手机号码长度必须为6位到14位之间',
            },
            voucherCard: {
                required: '此项为必填',
                rangelength: '超过最大输入长度'
            },
            useOrderNum: {
                customerCode: '不能超过64个字符，仅支持字母、数字、"/"、"-"'
            }
        }
    }

    var o1 = {}
    if ($.orderInfo.data.ticketInfoModel.cityType == 0) { //境内
        o1 = {
            rules: {
                surname: {
                    demostic: true,
                    rangelength: [1, 30]
                },
                userName: {
                    demostic: true,
                    rangelength: [1, 30]
                },
            },
            messages: {
                surname: {
                    rangelength: '请输入1-30个汉字或字母'
                },
                userName: {
                    rangelength: '请输入1-30个汉字或字母'
                }
            }
        }
    } else { //境外
        o1 = {
            rules: {
                surname: {
                    letter: true,
                    rangelength: [1, 30]
                },
                userName: {
                    letter: true,
                    rangelength: [1, 30]
                },
            },
            messages: {
                surname: {
                    letter: '请输入英文或拼音',
                    rangelength: '请输入1-30个字母'
                },
                userName: {
                    letter: '请输入英文或拼音',
                    rangelength: '请输入1-30个字母'
                }
            }
        }
    }

    $.extend(true, o, o1)
    $('#orderForm').validate(o)

    // $('.useUserInfo').change(() => {
    //   if($(this).prop('checked') == true){
    //     $("#orderForm").validate(o);
    //   }
    // })
}

module.exports = InitValidator



// WEBPACK FOOTER //
// ./src/js/ticketOrderConfirm/modules/initValidator.js